<template>
  <div class="p-3 bg-white">
    <div class="vx-row">
      <div class="vx-col w-full" id="modify-queue-queue-number-container">

        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('queue_number')"></label>
<!--          <v-select :options="queueOptions" :reduce="label => label.value" :placeholder="$t('please_select_a_queue_number')" v-model="modifyQueueFormData.queue_number" class="md:mb-0" @input="loadQueueExtensions"/>-->
          <select v-model="modifyQueueFormData.queue_number" class="vs-inputx vs-input--input normal md:mb-0" @change="loadQueueExtensions">
            <option value="">{{ $t('please_select_a_queue_number') }}</option>
            <option v-for="(option, key) in queueOptions" :key="'queue_number_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <div v-if="canSave">
            <label class="vs-input--label" v-text="$tc('extension', 2)"></label>
            <vx-input-group class="mb-1" v-for="(extension, key) in modifyQueueFormData.extensions" :key="key">
              <vs-input placeholder="Extension Number" v-model="modifyQueueFormData.extensions[key]" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    color="danger"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="removeExtension(key)">
                  </vs-button>
                </div>
              </template>
            </vx-input-group>

            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              @click.prevent="modifyQueueFormData.extensions.push('')">
              Add Extension
            </vs-button>
          </div>
        </div>

      </div>

    </div>
    <div class="text-center">
      <vs-button v-if="canSave" id="saveModifyQueue" class="m-2" color="primary" type="filled" @click.prevent="saveModifyQueue">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelModifyQueue">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Queue from '@/models/Queue'
import Node from '@/models/Node'
import io from 'socket.io-client'

export default {
  name: 'Window.Queue.Modify',
  data () {
    return {
      socket: null,
      server: {},
      queueStatusNode: {},
      modifyQueueFormData: {
        queue_number: '',
        extensions: []
      },
      queueOptions: [],
      canSave: false
    }
  },
  async mounted () {
    this.loadQueueOptions()
    const response = await Node.getServerAndNodeByLoggedInUser()
    this.queueStatusNode = response.data.server.queue_status
    this.server = response.data.server

    

  },
  methods: {
    async loadQueueOptions () {
      const response = await Queue.queuesOptions()
      this.queueOptions = response.data.queues
    },
    async loadQueueExtensions () {
      this.canSave = false
      const response = await Queue.queueExtension({queue: this.modifyQueueFormData.queue_number})
      this.modifyQueueFormData.queue_number = response.data.queue
      this.modifyQueueFormData.extensions = response.data.extensions

      if (this.socket && typeof this.socket.disconnect === 'function') {
        this.socket.disconnect()
      }

      const socketUrl = `${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`
      const socketOptions = { query: { queueno: response.data.queue }, transports: ['websocket'] }
      this.socket = io.connect(socketUrl, socketOptions)

      this.canSave = true
    },
    async saveModifyQueue () {
      if (this.canSave) {
        this.$vs.loading({background: 'primary', color: '#fff', container: '#saveModifyQueue', scale: 0.45})
        try {
          const response = await Queue.storeQueueExtension(this.modifyQueueFormData)
          if (response.data.success) {
            this.$swalHelper.success({
              title: this.$t('action_success'),
              text: this.$t(response.data.message),
              confirmButton: this.$t('confirm')
            })
          } else {
            this.$swalHelper.error({
              title: 'Error!',
              text: this.$t(response.data.message),
              confirmButton: this.$t('confirm')
            })
          }
          if (this.socket && typeof this.socket.emit === 'function') {
            this.socket.emit('modify-queue-run')
          }
        } catch (e) {
          const errors = this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
          this.companyFormErrors = errors.validationErrors
        }

        this.$vs.loading.close('#saveModifyQueue > .con-vs-loading')
      }
    },
    cancelModifyQueue () {
      window.close()
    },
    removeExtension (key) {
      this.modifyQueueFormData.extensions.splice(key, 1)
    }
  }
}
</script>

<style lang="scss">
#saveModifyQueue {
  .con-vs-loading {
    position: absolute !important;
  }
}
#modify-queue-queue-number-container ul.vs__dropdown-menu{
  max-height: 999px !important;
}
</style>
